import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { AppLanguageSwitcher } from '@/components/ui/AppLanguageSwitcher'
import { ShopQuayWordmark } from '@/components/brand/ShopQuayWordmark'
import CookieNotice from '@/components/layout/CookieNotice'
import MetaPixel from '@/components/marketing/MetaPixel'
import LoadingSpinner from '@/components/ui/LoadingSpinner'
import { SignupUatSandboxTip } from '@/components/signup/SignupUatSandboxTip'

/** Minimal chrome for ShopQuay self-serve signup wizard. */
const SignupLayout = () => {
  return (
    <div className="min-h-screen bg-[#0b1f3a] text-white">
      <MetaPixel />
      <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-6 sm:px-6">
        <ShopQuayWordmark
          to="/"
          variant="inverse"
          heightClassName="h-14 sm:h-16"
        />
        <AppLanguageSwitcher variant="compact" />
      </div>
      <main className="mx-auto max-w-3xl px-4 pb-16 sm:px-6">
        <Suspense
          fallback={
            <div className="flex min-h-[40vh] items-center justify-center">
              <LoadingSpinner />
            </div>
          }
        >
          <Outlet />
        </Suspense>
        <SignupUatSandboxTip className="mt-8" variant="onDark" />
      </main>
      <CookieNotice />
    </div>
  )
}

export default SignupLayout
